import React, { useState } from "react";
import {
    Row,
    Col,
    FormGroup,
    Label,
    Input,
    Container,
    FormFeedback,
    Form,
    Button,
} from "reactstrap";
import { Formik, FieldArray } from "formik";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { useNavigate } from "react-router-dom";
import ResultHandler from "../../../components/ResultHandler";
import FormButtonHandler from "../../../components/FormButtonHandler";
import { useResponse } from "../../../hooks/useResponse";
import { useTranslation } from "react-i18next";
import useCustomValidation from "../validationSchema";
import { addService } from "../../../api/service";

const AddService = () => {
    const { t } = useTranslation();
    const { addServiceSchema } = useCustomValidation();
    const navigate = useNavigate();

    // Optional: use state to hold initial values
    const [initialNames, setInitialNames] = useState([""]);

    const { setData, loading, error, success } = useResponse(addService, () => {
        navigate("/services/");
    });

    return (
        <div className="page-content">
            <Container fluid={true}>
                <Breadcrumbs title={`${t("btns.Add")} ${t("Service")}`} />

                <Formik
                    enableReinitialize
                    initialValues={{ names: initialNames }}
                    validationSchema={addServiceSchema}
                    onSubmit={(values) => {
                        // filter and remove empty names
                        const filteredNames = values.names.filter((name) => name.trim() !== "");
                        if (filteredNames.length === 0) {
                            alert(t("Please enter at least one valid service name"));
                            return;
                        }

                        const uniqueNames = Array.from(new Set(filteredNames.map(n => n.trim())));
                        setData({ data: { names: uniqueNames }, type: "add" });
                    }}
                >
                    {(formik) => (
                        <Form
                            className="needs-validation"
                            onSubmit={(e) => {
                                e.preventDefault();
                                formik.handleSubmit();
                            }}
                        >
                            <FieldArray name="names">
                                {(arrayHelpers) => (
                                    <>
                                        {formik.values.names.map((name, index) => (
                                            <Row key={index}>
                                                <Col md="6">
                                                    <FormGroup className="mb-3">
                                                        <Label>
                                                            {t("Name")} {index + 1}
                                                        </Label>
                                                        <Input
                                                            name={`names[${index}]`}
                                                            placeholder={t("Name")}
                                                            type="text"
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.names[index]}
                                                            invalid={
                                                                !!(
                                                                    formik.touched.names &&
                                                                    formik.touched.names[index] &&
                                                                    formik.errors.names &&
                                                                    formik.errors.names[index]
                                                                )
                                                            }
                                                        />
                                                        <FormFeedback>
                                                            {formik.errors.names && formik.errors.names[index]}
                                                        </FormFeedback>
                                                    </FormGroup>
                                                </Col>
                                                <Col md="2" className="d-flex align-items-center">
                                                    {index > 0 && (
                                                        <Button
                                                            type="button"
                                                            color="danger"
                                                            onClick={() => arrayHelpers.remove(index)}
                                                        >
                                                            {t("btns.Remove")}
                                                        </Button>
                                                    )}
                                                </Col>
                                            </Row>
                                        ))}
                                        <Button 
                                         style={{ marginRight: '20px' }}
                                            type="button"
                                            color="primary"
                                            onClick={() => {
                                                if (
                                                    formik.values.names.length === 0 ||
                                                    formik.values.names[formik.values.names.length - 1].trim() !== ""
                                                ) {
                                                    arrayHelpers.push("");
                                                }
                                            }}
                                        >
                                            {t("Add More")}
                                        </Button>
                                    </>
                                )}
                            </FieldArray>

                            <FormButtonHandler btnTxt={t("Add")} loading={loading} />

                            <ResultHandler
                                error={error}
                                success={success}
                                successMsg={t("Created Successfully!")}
                            />
                        </Form>
                    )}
                </Formik>
            </Container>
        </div>
    );
};

export default AddService;
